(function () {
  'use strict';

  angular.module('ringbaPortal').component('availablePingTrees', {
    bindings: {
      routeContainerType: '<', // either campaign or callplan
      routeContainer: '<',
      routeContainerRoutes: '<',
      onUpdate: '&',
      isRpc: '<'
    },
    controller: AvailablePingTreesController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/available-ping-trees.view.html'
  });

  function AvailablePingTreesController(
    $filter,
    $scope,
    $timeout,
    $uibModal,
    accountsService,
    campaignServiceNew,
    callPlanService,
    callRouteService,
    pingTreeService,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.currentRoute = {};
    vm.isRefreshingRingTrees = false;

    vm.$onChanges = onChanges;
    vm.cancelModal = cancelModal;
    vm.createNewRoute = createNewRoute;
    vm.newPingTreeRoute = newPingTreeRoute;
    vm.onSave = onSave;
    vm.addRouteToCampaignOrCallPlan = addRouteToCampaignOrCallPlan;
    vm.refreshRingTrees = refreshRingTrees;

    function onChanges(changesObj) {
      if (changesObj.routeContainerRoutes) {
        if (changesObj.routeContainerRoutes.isFirstChange()) {
          vm.loading = true;
        }
        _loadPingTrees();
      }
    }

    function cancelModal() {
      vm.currentRoute = undefined;
      vm.modal.close();
      vm.modal = null;
    }

    function createNewRoute() {
      vm.currentRoute.pingTreeId = vm.selectedPingTree.id;
      vm.currentRoute.callPingTree = vm.selectedPingTree;
      return addRouteToCampaignOrCallPlan(vm.currentRoute).then(function () {
        cancelModal();
        vm.onUpdate({
          routeContainer: vm.routeContainer
        });
      }).catch(utils.errorHandler);
    }



    function newPingTreeRoute(callPingTree) {
      vm.selectedPingTree = callPingTree;
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/select-target/new-ping-tree-route.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'xl'
      });
    }

    function onSave() {
      cancelModal();
      vm.onUpdate({
        routeContainer: vm.routeContainer
      });
    }

    function addRouteToCampaignOrCallPlan(route) {
      if (vm.routeContainerType === 'callPlan') {
        return callRouteService.createCallRoute(accountsService.currentAccountId, route).then(function (response) {
          return callPlanService.addRoute(accountsService.currentAccountId, vm.routeContainer.id, response.data.callRoute.id);
        });
      } else {
        return campaignServiceNew.addRoute(
          accountsService.currentAccountId,
          vm.routeContainer.id,
          route
        );
      }
    }

    function _loadPingTrees() {
      pingTreeService.getPingTrees(accountsService.currentAccountId, true)
        .then(function (response) {
          if (response && response.data && response.data.pingTrees && response.data.pingTrees.length > 0) {
            vm.noTargetAvailableMessage = $filter('translate')('CAMPAIGN_STEP_ROUTING_ALL_PING_TREES_ASSIGNED');
          } else {
            vm.noTargetAvailableMessage = $filter('translate')('CAMPAIGN_STEP_ROUTING_NONE_PING_TREES');
          }
          vm.pingTrees = $filter('notInCampaignRoutes')(response.data.pingTrees, vm.routeContainerRoutes, 'pingTree');
          vm.loading = false;
        })
        .catch(utils.errorHandler);
    }

    function refreshRingTrees() {
      vm.isRefreshingRingTrees = true;
      try {
        _loadPingTrees();
      } finally {
        $timeout(() => {
          vm.isRefreshingRingTrees = false;
        }, 600);
      }
    }
  }
})();
